import update from 'immutability-helper';
import _ from 'lodash';
import {
  useEffect,
  useState
} from 'react';

import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper
} from '@mui/material';



export function TableOfContents({
  items, defaultId
}: {
  defaultId: string;
  items: {
    id: string;
    label: string;
  }[];
}) {
  const [
    viewableTopics,
    setViewableTopics
  ] = useState<string[]>([_.first(items)?.id ?? defaultId]);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    for (const topic of items) {
      const el = document.getElementById(topic.id);
      if (el) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            setViewableTopics((prev) => {
              // Is viewable and not in array
              const arrayIndex = prev.indexOf(topic.id);
              const isInArray = arrayIndex > -1;
              const isViewable = entry.isIntersecting;

              if (isViewable && !isInArray) {
                return update(prev, {
                  $push: [topic.id]
                });

              } else if (!isViewable && isInArray) {
                if (prev.length === 1) {
                  return prev;
                }

                return update(prev, {
                  $splice: [[
                    arrayIndex,
                    1
                  ]]
                });
              }

              return prev;
            });
          },
          {
            threshold: 0.15
          }
        );

        observer.observe(el);
        observers.push(observer);
      }
    }

    return () => observers.forEach((obs) => obs.disconnect());
  }, [
    viewableTopics,
    items
  ]);

  return (
    <Paper>
      <List dense>
        {items.map((topic) => (
          <ListItem key={topic.id}>
            <ListItemButton
              dense
              selected={_.last(viewableTopics) === topic.id}
              onClick={() => {
                document.getElementById(topic.id)?.scrollIntoView({
                  behavior: 'smooth'
                });
              }}
            >
              <ListItemText primary={topic.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
